import { useEffect, useState } from 'react';
import CustomAppBar from '../../components/CustomAppBar';
import { Box, Button, Card, Container, Grid, TextField, Typography, Chip, CircularProgress, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { useNavigate, useParams, useOutletContext } from 'react-router-dom';
import AlertBar from '../../components/AlertBar';
import { fatafatDollarActions } from '../../store/reducer/fatafat-dollar';
import { isEmpty } from 'lodash';

const FatafatDollarPlaceBid = ({ 
    isFatafatDollarLoading, 
    fatafatDollarGameRateData,
    isSubmitFatafatDollarBidSuccess,
    isSubmitFatafatDollarBidFailed,
    fatafatDollarMsg 
}: any) => {
    const { gameId, gameTypeId, session } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const outletdata: any = useOutletContext();
    
    const userDataSession: any = localStorage.getItem('userData');
    const userData = JSON.parse(userDataSession);

    const [bids, setBids] = useState<any>([]);
    const [currentDigit, setCurrentDigit] = useState('');
    const [currentPoints, setCurrentPoints] = useState<any>('');
    const [errorMessage, setErrorMessage] = useState<any>({ status: false, message: '', severity: '', inputName: '' });
    const [gameTypeName, setGameTypeName] = useState('');
    const [gameTypeLabel, setGameTypeLabel] = useState('');
    const [selectedSession, setSelectedSession] = useState('Open');
    const [gameTiming, setGameTiming] = useState<any>(null);
    const [gameStatus, setGameStatus] = useState<any>(null);
    const [autoInputValue, setAutoInputValue] = useState('');
    const [jackpotSuggestions, setJackpotSuggestions] = useState<string[]>([]);

    // Game types mapping
    const gameTypes: any = {
        '1': { name: 'Single Digit', label: 'Ankda/Single Ank', digits: 1 },
        '2': { name: 'Jodi Digit', label: 'Jodi', digits: 2 },
        '3': { name: 'Single Pana', label: 'SP Pana', digits: 3 },
        '4': { name: 'Double Pana', label: 'DP Pana', digits: 3 },
        '5': { name: 'Triple Pana', label: 'Tripple Pana', digits: 3 },
        '6': { name: 'SP Motor', label: 'SP Motor', digits: 3 },
        '7': { name: 'DP Motor', label: 'DP Motor', digits: 3 },
        '8': { name: 'Jackpot', label: 'Jackpot', digits: 3 },
        '9': { name: 'Series SP', label: 'Series SP', digits: 3 },
        '10': { name: 'Series DP', label: 'Series DP', digits: 3 },
        '11': { name: 'Series SP DP TP', label: 'Series SP DP TP', digits: 3 },
        '12': { name: 'Block', label: 'Block', digits: 3 },
        '13': { name: 'All SP DP TP', label: 'All SP DP TP', digits: 3 },
        '14': { name: 'Panna', label: 'Panna', digits: 3 },
        '15': { name: 'SP DP Motor', label: 'SP DP Motor', digits: 3 }
    };

    useEffect(() => {
        const data: any = {
            app_key: "@34Y@#8deepmatka",
        };
        dispatch(fatafatDollarActions.fatafatDollarGameRatesReq(data));

        if(gameTypeId && gameTypes[gameTypeId]) {
            setGameTypeName(gameTypes[gameTypeId].name);
            setGameTypeLabel(gameTypes[gameTypeId].label);
        }

        // Fetch game timing information
        if(gameId) {
            fetchGameTiming();
        }
    }, [gameId]);


    useEffect(() => {
        // Check game status when component loads
        if(gameId && selectedSession) {
            checkGameStatus(selectedSession);
        }
    }, [gameId, selectedSession]);

    const fetchGameTiming = async () => {
        try {
            const response = await fetch('http://localhost/super2/index.php/Fatafatdollarapicontroller/apiFatafatDollarGames', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    app_key: "@34Y@#8deepmatka"
                })
            });
            
            const data = await response.json();
            if(data.status && data.games) {
                const currentGame = data.games.find((game: any) => game.game_id == gameId);
                if(currentGame) {
                    setGameTiming({
                        open_time: currentGame.open_time,
                        close_time: currentGame.close_time,
                        game_name: currentGame.game_name
                    });
                }
            }
        } catch (error) {
            console.error('Error fetching game timing:', error);
        }
    };

    const checkGameStatus = async (session: string) => {
        try {
            const response = await fetch('https://1000dollar.fun/super/index.php/Fatafatdollarapicontroller/apiCheckFatafatDollarGameStatus', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    app_key: "@34Y@#8deepmatka",
                    game_id: gameId,
                    session: session
                })
            });
            
            const data = await response.json();
            setGameStatus(data);
            return data;
        } catch (error) {
            console.error('Error checking game status:', error);
            return null;
        }
    };

    useEffect(() => {
        if (isSubmitFatafatDollarBidSuccess) {
            setErrorMessage({ status: true, message: fatafatDollarMsg, severity: 'success', inputName: '' });
            setBids([]);
            setCurrentDigit('');
            setCurrentPoints('');
            setAutoInputValue('');
            dispatch(fatafatDollarActions.resetFatafatDollar());
        }
    }, [isSubmitFatafatDollarBidSuccess]);

    useEffect(() => {
        if (isSubmitFatafatDollarBidFailed) {
            setErrorMessage({ status: true, message: fatafatDollarMsg, severity: 'error', inputName: '' });
            dispatch(fatafatDollarActions.resetFatafatDollar());
        }
    }, [isSubmitFatafatDollarBidFailed]);

    const addToBidCart = () => {
        if (!currentDigit) {
            setErrorMessage({ status: true, message: 'Please enter digit/number', severity: 'warning', inputName: '' });
            return;
        }

        const expectedLength = gameTypes[gameTypeId || '1'].digits;
        if (currentDigit.length !== expectedLength) {
            setErrorMessage({ status: true, message: `Please enter ${expectedLength} digit(s)`, severity: 'warning', inputName: '' });
            return;
        }

        if (!currentPoints || currentPoints === '') {
            setErrorMessage({ status: true, message: 'Please enter points', severity: 'warning', inputName: '' });
            return;
        }

        const minBidAmount = outletdata?.walletBalance?.min_bid_amount || 10;
        if (parseInt(currentPoints) < minBidAmount) {
            setErrorMessage({ status: true, message: `Minimum points is ${minBidAmount}`, severity: 'warning', inputName: '' });
            return;
        }

        const newBid = {
            digits: currentDigit,
            closedigits: '',
            points: parseInt(currentPoints)
        };

        setBids([...bids, newBid]);
        setCurrentDigit('');
        setErrorMessage({ status: true, message: 'Bid added to cart!', severity: 'success', inputName: '' });
    };

    // Auto input handler for all game types
    const handleAutoInput = (e: any) => {
        const value = e.target.value.toUpperCase();
        
        // Check if points are entered
        if (!currentPoints || currentPoints === '') {
            setErrorMessage({ status: true, message: 'Please enter points first!', severity: 'warning', inputName: '' });
            return;
        }

        const minBidAmount = outletdata?.walletBalance?.min_bid_amount || 10;
        if (parseInt(currentPoints) < minBidAmount) {
            setErrorMessage({ status: true, message: `Minimum points is ${minBidAmount}`, severity: 'warning', inputName: '' });
            return;
        }

        // Handle backspace/deletion - if input value becomes shorter, remove last bid
        const previousValue = autoInputValue.replace(/,\s*$/, ''); // Remove trailing comma
        const currentValue = value.replace(/,\s*$/, ''); // Remove trailing comma
        
        if (currentValue.length < previousValue.length && bids.length > 0) {
            // User is deleting - remove last bid
            const newBids = bids.slice(0, -1);
            setBids(newBids);
            
            // Rebuild input value from remaining bids
            const displayValue = newBids.map((bid: any) => bid.digits).join(',');
            setAutoInputValue(displayValue ? displayValue + ',' : '');
            setErrorMessage({ status: true, message: 'Last bid removed!', severity: 'info', inputName: '' });
            return;
        }

        // Special handling for Motor SP (Half Sangam - gameTypeId 6)
        if (gameTypeId === '6') {
            handleMotorSPInput(value);
            return;
        }

        // Special handling for Motor DP (Full Sangam - gameTypeId 7)
        if (gameTypeId === '7') {
            handleMotorDPInput(value);
            return;
        }

        // Special handling for Series SP (gameTypeId 9) - Generate all SP with given digits
        if (gameTypeId === '9') {
            handleSeriesSPInput(value);
            return;
        }

        // Special handling for Series DP (gameTypeId 10) - Generate all DP with given digits
        if (gameTypeId === '10') {
            handleSeriesDPInput(value);
            return;
        }

        // Special handling for Series SP DP TP (gameTypeId 11) - Manual entry, all types allowed
        if (gameTypeId === '11') {
            handleSeriesSPDPTPInput(value);
            return;
        }

        // Special handling for All SP DP TP (gameTypeId 13) - Auto-generates all combinations
        if (gameTypeId === '13') {
            handleAllSPDPTPInput(value);
            return;
        }

        // Special handling for Block (gameTypeId 12) - Auto-generates SP or DP combinations only
        if (gameTypeId === '12') {
            handleBlockInput(value);
            return;
        }

        // Special handling for Panna (gameTypeId 14) - Manual single panna entry
        if (gameTypeId === '14') {
            handlePannaInput(value);
            return;
        }

        // Special handling for SP DP Motor (gameTypeId 15) - Combination of both motors
        if (gameTypeId === '15') {
            handleSPDPMotorInput(value);
            return;
        }

        const expectedDigits = gameTypes[gameTypeId || '1'].digits;
        
        // Different handling based on game type
        if (gameTypeId === '8') {
            // Jackpot: A1-A11, B1-B11, ... J1-J11 (10 alphabets, 1-11 numbers)
            const upperValue = value.toUpperCase();
            
            // Get current incomplete input (after last comma)
            const parts = upperValue.split(',');
            const currentInput = parts[parts.length - 1].trim().replace(/[^A-J0-9]/g, '');
            
            // Generate suggestions based on current input
            if (currentInput.length > 0 && /^[A-J]/.test(currentInput[0])) {
                const letter = currentInput[0];
                const suggestions: string[] = [];
                
                // Generate A1-A11 suggestions for the typed letter
                for (let num = 1; num <= 11; num++) {
                    suggestions.push(letter + num);
                }
                
                setJackpotSuggestions(suggestions);
            } else {
                setJackpotSuggestions([]);
            }
            
            // Parse all complete jackpot codes (separated by comma)
            const allValidCodes: string[] = [];
            parts.forEach((part: string) => {
                const cleaned = part.trim().replace(/[^A-J0-9]/g, '');
                
                if (cleaned.length >= 2) {
                    const letter = cleaned[0];
                    const numberStr = cleaned.substring(1);
                    const numValue = parseInt(numberStr);
                    
                    if (/[A-J]/.test(letter) && numValue >= 1 && numValue <= 11) {
                        const code = letter + numberStr;
                        if (!allValidCodes.includes(code)) {
                            allValidCodes.push(code);
                        }
                    }
                }
            });
            
            const currentBidsCount = bids.length;
            
            // If we have more valid codes than current bids
            if (allValidCodes.length > currentBidsCount) {
                const nextEntry = allValidCodes[currentBidsCount];
                const currentBidDigits = bids.map((bid: any) => bid.digits);
                
                if (!currentBidDigits.includes(nextEntry)) {
                    const newBid = {
                        digits: nextEntry,
                        closedigits: '',
                        points: parseInt(currentPoints)
                    };

                    setBids([...bids, newBid]);
                    
                    setErrorMessage({ 
                        status: true, 
                        message: `Jackpot: Added ${nextEntry}`, 
                        severity: 'success', 
                        inputName: '' 
                    });
                } else {
                    setErrorMessage({ status: true, message: `${nextEntry} already added!`, severity: 'warning', inputName: '' });
                }
            }
            
            setAutoInputValue(upperValue);
        } else {
            // For Single Digit (1), Jodi (2), Single/Double/Triple Pana (3,4,5,6,7)
            const digitsOnly = value.replace(/[^0-9]/g, '');
            
            // Calculate how many complete entries we can form from the digits
            const totalPossibleEntries = Math.floor(digitsOnly.length / expectedDigits);
            const currentBidsCount = bids.length;
            
            // If we can form more entries than we have in bids
            if (totalPossibleEntries > currentBidsCount) {
                // Extract the next entry that should be added (based on bid count)
                const startPos = currentBidsCount * expectedDigits;
                const nextEntry = digitsOnly.substring(startPos, startPos + expectedDigits);
                
                if (nextEntry.length === expectedDigits) {
                    // Validation for Single Pana (gameTypeId = 3 or 9) - All digits must be unique
                    if (gameTypeId === '3' || gameTypeId === '9') {
                        const digits = nextEntry.split('');
                        const uniqueDigits = new Set(digits);
                        
                        if (uniqueDigits.size !== digits.length) {
                            setErrorMessage({ 
                                status: true, 
                                message: `Invalid SP Pana: ${nextEntry} - All three digits must be different!`, 
                                severity: 'error', 
                                inputName: '' 
                            });
                            // Reset to previous valid state
                            const displayValue = bids.map((bid: any) => bid.digits).join(',');
                            setAutoInputValue(displayValue ? displayValue + ',' : '');
                            return;
                        }
                    }
                    
                    // Validation for Double Pana (gameTypeId = 4 or 10) - Exactly 2 digits must be same
                    if (gameTypeId === '4' || gameTypeId === '10') {
                        const digits = nextEntry.split('');
                        const uniqueDigits = new Set(digits);
                        
                        // For DP, we need exactly 2 unique digits (meaning one digit repeats twice)
                        if (uniqueDigits.size !== 2) {
                            let errorMsg = '';
                            if (uniqueDigits.size === 1) {
                                errorMsg = `Invalid DP Pana: ${nextEntry} - All three digits are same! Need exactly 2 matching digits.`;
                            } else {
                                errorMsg = `Invalid DP Pana: ${nextEntry} - All digits are different! Need exactly 2 matching digits (e.g., 220, 303).`;
                            }
                            setErrorMessage({ 
                                status: true, 
                                message: errorMsg, 
                                severity: 'error', 
                                inputName: '' 
                            });
                            // Reset to previous valid state
                            const displayValue = bids.map((bid: any) => bid.digits).join(',');
                            setAutoInputValue(displayValue ? displayValue + ',' : '');
                            return;
                        }
                    }
                    
                    // Validation for Triple Pana (gameTypeId = 5) - All 3 digits must be same
                    if (gameTypeId === '5') {
                        const digits = nextEntry.split('');
                        const uniqueDigits = new Set(digits);
                        
                        // For Triple Pana, we need exactly 1 unique digit (all same)
                        if (uniqueDigits.size !== 1) {
                            setErrorMessage({ 
                                status: true, 
                                message: `Invalid Triple Pana: ${nextEntry} - All three digits must be SAME! (e.g., 111, 222, 333)`, 
                                severity: 'error', 
                                inputName: '' 
                            });
                            // Reset to previous valid state
                            const displayValue = bids.map((bid: any) => bid.digits).join(',');
                            setAutoInputValue(displayValue ? displayValue + ',' : '');
                            return;
                        }
                    }
                    
                    const currentBidDigits = bids.map((bid: any) => bid.digits);
                    
                    if (!currentBidDigits.includes(nextEntry)) {
                        const newBid = {
                            digits: nextEntry,
                            closedigits: '',
                            points: parseInt(currentPoints)
                        };

                        setBids([...bids, newBid]);
                        
                        // Build the display value from all bids
                        const displayValue = [...bids, newBid].map((bid: any) => bid.digits).join(',');
                        setAutoInputValue(displayValue + ',');
                    } else {
                        setErrorMessage({ status: true, message: `Number ${nextEntry} already added!`, severity: 'warning', inputName: '' });
                    }
                    return;
                }
            }
            setAutoInputValue(value);
        }
    };

    const removeBid = (index: number) => {
        const newBids = bids.filter((_: any, i: number) => i !== index);
        setBids(newBids);
        
        // Update auto input value for all game types
        const remainingDigits = newBids.map((bid: any) => bid.digits).join(',');
        setAutoInputValue(remainingDigits ? remainingDigits + ',' : '');
    };

    // Handle jackpot suggestion click
    const handleJackpotSuggestionClick = (suggestion: string) => {
        const currentBidDigits = bids.map((bid: any) => bid.digits);
        
        if (!currentBidDigits.includes(suggestion)) {
            const newBid = {
                digits: suggestion,
                closedigits: '',
                points: parseInt(currentPoints)
            };

            setBids([...bids, newBid]);
            
            // Clear input and suggestions, ready for next entry
            setAutoInputValue('');
            setJackpotSuggestions([]);
            
            setErrorMessage({ 
                status: true, 
                message: `Jackpot: Added ${suggestion}`, 
                severity: 'success', 
                inputName: '' 
            });
        } else {
            setErrorMessage({ status: true, message: `${suggestion} already added!`, severity: 'warning', inputName: '' });
        }
    };

    // Generate all permutations of a specific 3-digit string (for Block)
    const generateStringPermutations = (str: string): string[] => {
        if (str.length !== 3) return [];
        
        const permutations: string[] = [];
        const chars = str.split('');
        
        // Generate all permutations using a simple algorithm
        const permute = (arr: string[], index: number = 0) => {
            if (index === arr.length - 1) {
                const perm = arr.join('');
                if (!permutations.includes(perm)) {
                    permutations.push(perm);
                }
                return;
            }
            
            for (let i = index; i < arr.length; i++) {
                [arr[index], arr[i]] = [arr[i], arr[index]]; // Swap
                permute([...arr], index + 1);
            }
        };
        
        permute(chars);
        return permutations;
    };

    // Generate all 3-digit permutations with unique digits (for Motor SP - gameTypeId 6)
    const generateSPPermutations = (digits: string) => {
        const uniqueSet = new Set(digits.split(''));
        const uniqueDigits = Array.from(uniqueSet);
        const permutations: string[] = [];
        
        // Generate all 3-digit permutations where all digits are different
        for (let i = 0; i < uniqueDigits.length; i++) {
            for (let j = 0; j < uniqueDigits.length; j++) {
                if (j === i) continue; // Skip if same position
                for (let k = 0; k < uniqueDigits.length; k++) {
                    if (k === i || k === j) continue; // Skip if same as previous
                    const combination = uniqueDigits[i] + uniqueDigits[j] + uniqueDigits[k];
                    permutations.push(combination);
                }
            }
        }
        
        return permutations;
    };

    // Generate all 3-digit permutations with exactly 2 same digits (for Motor DP - gameTypeId 7)
    const generateDPPermutations = (digits: string) => {
        const uniqueSet = new Set(digits.split(''));
        const uniqueDigits = Array.from(uniqueSet);
        const permutations: string[] = [];
        
        // For each pair of digits (i, j) where i repeats twice and j appears once
        for (let i = 0; i < uniqueDigits.length; i++) {
            for (let j = 0; j < uniqueDigits.length; j++) {
                if (i === j) continue; // Need different digits
                
                const repeatingDigit = uniqueDigits[i];
                const singleDigit = uniqueDigits[j];
                
                // Generate all permutations: AAB, ABA, BAA
                permutations.push(repeatingDigit + repeatingDigit + singleDigit); // AAB
                permutations.push(repeatingDigit + singleDigit + repeatingDigit); // ABA
                permutations.push(singleDigit + repeatingDigit + repeatingDigit); // BAA
            }
        }
        
        return permutations;
    };

    // Handle Motor SP (Half Sangam) auto-generation
    const handleMotorSPInput = (value: string) => {
        const digitsOnly = value.replace(/[^0-9]/g, '');
        
        // Need at least 3 unique digits to generate SP Pana
        const uniqueSet = new Set(digitsOnly.split(''));
        const uniqueDigits = Array.from(uniqueSet);
        
        if (uniqueDigits.length >= 3) {
            // Generate all SP Pana permutations
            const permutations = generateSPPermutations(digitsOnly);
            
            // Create bids for each permutation
            const newBids = permutations.map(perm => ({
                digits: perm,
                closedigits: '',
                points: parseInt(currentPoints)
            }));
            
            setBids(newBids);
            setAutoInputValue(digitsOnly);
            setErrorMessage({ 
                status: true, 
                message: `Generated ${permutations.length} SP Pana combinations from digits: ${uniqueDigits.join('')}`, 
                severity: 'success', 
                inputName: '' 
            });
        } else {
            setAutoInputValue(value);
            if (digitsOnly.length > 0 && uniqueDigits.length < 3) {
                setErrorMessage({ 
                    status: true, 
                    message: `Need at least 3 different digits. Currently have: ${uniqueDigits.length}`, 
                    severity: 'info', 
                    inputName: '' 
                });
            }
        }
    };

    // Handle Motor DP (Full Sangam) auto-generation
    const handleMotorDPInput = (value: string) => {
        const digitsOnly = value.replace(/[^0-9]/g, '');
        
        // Need at least 2 unique digits to generate DP Pana
        const uniqueSet = new Set(digitsOnly.split(''));
        const uniqueDigits = Array.from(uniqueSet);
        
        if (uniqueDigits.length >= 2) {
            // Generate all DP Pana permutations
            const permutations = generateDPPermutations(digitsOnly);
            
            // Create bids for each permutation
            const newBids = permutations.map(perm => ({
                digits: perm,
                closedigits: '',
                points: parseInt(currentPoints)
            }));
            
            setBids(newBids);
            setAutoInputValue(digitsOnly);
            setErrorMessage({ 
                status: true, 
                message: `Generated ${permutations.length} DP Pana combinations from digits: ${uniqueDigits.join('')}`, 
                severity: 'success', 
                inputName: '' 
            });
        } else {
            setAutoInputValue(value);
            if (digitsOnly.length > 0 && uniqueDigits.length < 2) {
                setErrorMessage({ 
                    status: true, 
                    message: `Need at least 2 different digits. Currently have: ${uniqueDigits.length}`, 
                    severity: 'info', 
                    inputName: '' 
                });
            }
        }
    };

    // Generate all TP (Triple Pana) permutations - all same digits
    const generateTPPermutations = (digits: string) => {
        const uniqueSet = new Set(digits.split(''));
        const uniqueDigits = Array.from(uniqueSet);
        const permutations: string[] = [];
        
        // For each unique digit, create a triple pana (e.g., 111, 222, etc.)
        for (let i = 0; i < uniqueDigits.length; i++) {
            const digit = uniqueDigits[i];
            permutations.push(digit + digit + digit);
        }
        
        return permutations;
    };

    // Generate SP combinations for given digits
    const generateSeriesSPCombinations = (inputDigits: string[]): string[] => {
        const allDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        const spCombinations: string[] = [];
        
        // Generate all SP (3-digit) combinations that contain ALL input digits
        for (let i = 0; i < allDigits.length; i++) {
            for (let j = 0; j < allDigits.length; j++) {
                for (let k = 0; k < allDigits.length; k++) {
                    // All digits must be different (SP rule)
                    if (i === j || j === k || i === k) continue;
                    
                    const combination = allDigits[i] + allDigits[j] + allDigits[k];
                    
                    // Check if combination contains ALL input digits
                    const hasAllInputDigits = inputDigits.every(digit => combination.includes(digit));
                    
                    if (hasAllInputDigits) {
                        spCombinations.push(combination);
                    }
                }
            }
        }
        
        return spCombinations;
    };

    // Handle Series SP input (gameTypeId 9) - Generate all SP numbers with given digits
    const handleSeriesSPInput = (value: string) => {
        const digitsOnly = value.replace(/[^0-9]/g, '');
        
        // Get existing source series from bids
        const existingSourceSeries: string[] = [];
        if (bids.length > 0) {
            bids.forEach((bid: any) => {
                if (bid.sourceSeries && !existingSourceSeries.includes(bid.sourceSeries)) {
                    existingSourceSeries.push(bid.sourceSeries);
                }
            });
        }
        
        // Calculate how many complete series (minimum 2 digits each) we can form
        const currentSeriesCount = existingSourceSeries.length;
        
        // Handle backspace/deletion
        const previousValue = autoInputValue.replace(/,\s*$/, '');
        const currentValue = value.replace(/,\s*$/, '');
        
        if (currentValue.length < previousValue.length && bids.length > 0) {
            const prevSeries = previousValue.split(',').filter((s: string) => s.length >= 2);
            const newSeries = currentValue.split(',').filter((s: string) => s.length >= 2);
            
            if (prevSeries.length > newSeries.length && existingSourceSeries.length > 0) {
                // Remove last series bids
                const lastSourceSeries = existingSourceSeries[existingSourceSeries.length - 1];
                const newBids = bids.filter((bid: any) => bid.sourceSeries !== lastSourceSeries);
                setBids(newBids);
                
                const remainingSourceSeries = existingSourceSeries.slice(0, -1);
                const displayValue = remainingSourceSeries.join(',');
                setAutoInputValue(displayValue ? displayValue + ',' : '');
                setErrorMessage({ status: true, message: 'Last series removed!', severity: 'info', inputName: '' });
                return;
            }
        }
        
        // Try to parse a new series (minimum 2 digits, no limit on max)
        // Get the current incomplete series by finding digits after last comma
        const allInputSeries = value.split(',').map((s: string) => s.trim()).filter((s: string) => s.length > 0);
        const currentInputSeries = allInputSeries[allInputSeries.length - 1] || '';
        const digitsInCurrentSeries = currentInputSeries.replace(/[^0-9]/g, '');
        
        // Check if we have enough digits to process (at least 2)
        if (digitsInCurrentSeries.length >= 2 && allInputSeries.length > currentSeriesCount) {
            // Validate: all digits must be different
            const digitSet = new Set(digitsInCurrentSeries.split(''));
            if (digitSet.size !== digitsInCurrentSeries.length) {
                setErrorMessage({ 
                    status: true, 
                    message: `Invalid input: ${digitsInCurrentSeries} - All digits must be different! No repeated digits allowed.`, 
                    severity: 'error', 
                    inputName: '' 
                });
                // Reset to previous valid state
                const displayValue = existingSourceSeries.join(',');
                setAutoInputValue(displayValue ? displayValue + ',' : '');
                return;
            }
            
            const inputDigits = digitsInCurrentSeries.split('');
            const spCombinations = generateSeriesSPCombinations(inputDigits);
            
            // Create bids for this series
            const newBidsForSeries = spCombinations.map(combo => ({
                digits: combo,
                closedigits: '',
                points: parseInt(currentPoints),
                sourceSeries: digitsInCurrentSeries
            }));
            
            // Add to existing bids
            const updatedBids = [...bids, ...newBidsForSeries];
            setBids(updatedBids);
            
            // Update display value
            const updatedSourceSeries = [...existingSourceSeries, digitsInCurrentSeries];
            const displayValue = updatedSourceSeries.join(',');
            setAutoInputValue(displayValue + ',');
            
            setErrorMessage({ 
                status: true, 
                message: `Series SP: Added ${spCombinations.length} SP combinations for digits: ${inputDigits.join('')}`, 
                severity: 'success', 
                inputName: '' 
            });
        } else {
            setAutoInputValue(value);
            if (digitsInCurrentSeries.length > 0 && digitsInCurrentSeries.length < 2) {
                setErrorMessage({ 
                    status: true, 
                    message: `Need at least 2 different digits for series. Currently have: ${digitsInCurrentSeries.length}`, 
                    severity: 'info', 
                    inputName: '' 
                });
            }
        }
    };

    // Generate DP combinations for given digits (with repetition allowed)
    const generateSeriesDPCombinations = (inputDigits: string): string[] => {
        const dpCombinations: string[] = [];
        
        // Get unique digits from input
        const uniqueDigits = Array.from(new Set(inputDigits.split('')));
        
        // For each unique digit, generate DP combinations where it repeats
        uniqueDigits.forEach(repeatingDigit => {
            // Find other unique digits to use as the single digit
            uniqueDigits.forEach(singleDigit => {
                if (singleDigit === repeatingDigit) return; // Skip same digit (would make TP)
                
                // Generate only 2 permutations:
                // 1. AAB format: repeating digit at start and middle (e.g., 112)
                const permutation1 = repeatingDigit + repeatingDigit + singleDigit;
                dpCombinations.push(permutation1);
                
                // 2. BAA format: single digit at start (e.g., 211)
                const permutation2 = singleDigit + repeatingDigit + repeatingDigit;
                dpCombinations.push(permutation2);
                
                // 3. ABA format: single digit in middle (e.g., 121)
                const permutation3 = repeatingDigit + singleDigit + repeatingDigit;
                dpCombinations.push(permutation3);
            });
        });
        
        return dpCombinations;
    };

    // Handle Series DP input (gameTypeId 10) - Generate all DP numbers with given digits (repetition allowed)
    const handleSeriesDPInput = (value: string) => {
        const digitsOnly = value.replace(/[^0-9]/g, '');
        
        // Get existing source series from bids
        const existingSourceSeries: string[] = [];
        if (bids.length > 0) {
            bids.forEach((bid: any) => {
                if (bid.sourceSeries && !existingSourceSeries.includes(bid.sourceSeries)) {
                    existingSourceSeries.push(bid.sourceSeries);
                }
            });
        }
        
        const currentSeriesCount = existingSourceSeries.length;
        
        // Handle backspace/deletion
        const previousValue = autoInputValue.replace(/,\s*$/, '');
        const currentValue = value.replace(/,\s*$/, '');
        
        if (currentValue.length < previousValue.length && bids.length > 0) {
            const prevSeries = previousValue.split(',').filter((s: string) => s.length >= 2);
            const newSeries = currentValue.split(',').filter((s: string) => s.length >= 2);
            
            if (prevSeries.length > newSeries.length && existingSourceSeries.length > 0) {
                // Remove last series bids
                const lastSourceSeries = existingSourceSeries[existingSourceSeries.length - 1];
                const newBids = bids.filter((bid: any) => bid.sourceSeries !== lastSourceSeries);
                setBids(newBids);
                
                const remainingSourceSeries = existingSourceSeries.slice(0, -1);
                const displayValue = remainingSourceSeries.join(',');
                setAutoInputValue(displayValue ? displayValue + ',' : '');
                setErrorMessage({ status: true, message: 'Last series removed!', severity: 'info', inputName: '' });
                return;
            }
        }
        
        // Parse input series
        const allInputSeries = value.split(',').map((s: string) => s.trim()).filter((s: string) => s.length > 0);
        const currentInputSeries = allInputSeries[allInputSeries.length - 1] || '';
        const digitsInCurrentSeries = currentInputSeries.replace(/[^0-9]/g, '');
        
        // Need at least 2 digits (can be same for DP)
        if (digitsInCurrentSeries.length >= 2 && allInputSeries.length > currentSeriesCount) {
            const dpCombinations = generateSeriesDPCombinations(digitsInCurrentSeries);
            
            // Create bids for this series
            const newBidsForSeries = dpCombinations.map(combo => ({
                digits: combo,
                closedigits: '',
                points: parseInt(currentPoints),
                sourceSeries: digitsInCurrentSeries
            }));
            
            // Add to existing bids
            const updatedBids = [...bids, ...newBidsForSeries];
            setBids(updatedBids);
            
            // Update display value
            const updatedSourceSeries = [...existingSourceSeries, digitsInCurrentSeries];
            const displayValue = updatedSourceSeries.join(',');
            setAutoInputValue(displayValue + ',');
            
            setErrorMessage({ 
                status: true, 
                message: `Series DP: Added ${dpCombinations.length} DP combinations for digits: ${digitsInCurrentSeries}`, 
                severity: 'success', 
                inputName: '' 
            });
        } else {
            setAutoInputValue(value);
            if (digitsInCurrentSeries.length > 0 && digitsInCurrentSeries.length < 2) {
                setErrorMessage({ 
                    status: true, 
                    message: `Need at least 2 digits for DP series. Currently have: ${digitsInCurrentSeries.length}`, 
                    severity: 'info', 
                    inputName: '' 
                });
            }
        }
    };

    // Handle Series SP DP TP input (gameTypeId 11) - Auto-generate SP combinations
    const handleSeriesSPDPTPInput = (value: string) => {
        const digitsOnly = value.replace(/[^0-9]/g, '');
        
        // Get existing source series from bids
        const existingSourceSeries: string[] = [];
        if (bids.length > 0) {
            bids.forEach((bid: any) => {
                if (bid.sourceSeries && !existingSourceSeries.includes(bid.sourceSeries)) {
                    existingSourceSeries.push(bid.sourceSeries);
                }
            });
        }
        
        const currentSeriesCount = existingSourceSeries.length;
        
        // Handle backspace/deletion
        const previousValue = autoInputValue.replace(/,\s*$/, '');
        const currentValue = value.replace(/,\s*$/, '');
        
        if (currentValue.length < previousValue.length && bids.length > 0) {
            const prevSeries = previousValue.split(',').filter((s: string) => s.length >= 2);
            const newSeries = currentValue.split(',').filter((s: string) => s.length >= 2);
            
            if (prevSeries.length > newSeries.length && existingSourceSeries.length > 0) {
                // Remove last series bids
                const lastSourceSeries = existingSourceSeries[existingSourceSeries.length - 1];
                const newBids = bids.filter((bid: any) => bid.sourceSeries !== lastSourceSeries);
                setBids(newBids);
                
                const remainingSourceSeries = existingSourceSeries.slice(0, -1);
                const displayValue = remainingSourceSeries.join(',');
                setAutoInputValue(displayValue ? displayValue + ',' : '');
                setErrorMessage({ status: true, message: 'Last series removed!', severity: 'info', inputName: '' });
                return;
            }
        }
        
        // Parse input series
        const allInputSeries = value.split(',').map((s: string) => s.trim()).filter((s: string) => s.length > 0);
        const currentInputSeries = allInputSeries[allInputSeries.length - 1] || '';
        const digitsInCurrentSeries = currentInputSeries.replace(/[^0-9]/g, '');
        
        // Need at least 2 digits
        if (digitsInCurrentSeries.length >= 2 && allInputSeries.length > currentSeriesCount) {
            const inputDigits = digitsInCurrentSeries.split('');
            const uniqueDigits = Array.from(new Set(inputDigits));
            const allCombinations: any[] = [];
            
            // Check if all digits are same (e.g., "11", "22", "333")
            if (uniqueDigits.length === 1) {
                // Case: Same digit repeated (e.g., "11", "22")
                const repeatingDigit = uniqueDigits[0];
                
                // 1. Generate DP combinations (two repeating + one different digit)
                // Only 2 permutations per digit: AAB and BAA (skip ABA)
                for (let otherDigit = 0; otherDigit <= 9; otherDigit++) {
                    const otherDigitStr = otherDigit.toString();
                    if (otherDigitStr === repeatingDigit) continue; // Skip same digit
                    
                    // Generate only 2 permutations (same as Series DP)
                    const perm1 = repeatingDigit + repeatingDigit + otherDigitStr; // AAB: 118
                    const perm2 = otherDigitStr + repeatingDigit + repeatingDigit; // BAA: 811
                    // Skip ABA: 181
                    
                    [perm1, perm2].forEach(perm => {
                        allCombinations.push({
                            digits: perm,
                            closedigits: '',
                            points: parseInt(currentPoints),
                            sourceSeries: digitsInCurrentSeries,
                            panaType: 'Double Pana'
                        });
                    });
                }
                
                // 2. Add TP combination (all three same)
                const tpCombo = repeatingDigit + repeatingDigit + repeatingDigit; // 111, 222, etc.
                allCombinations.push({
                    digits: tpCombo,
                    closedigits: '',
                    points: parseInt(currentPoints),
                    sourceSeries: digitsInCurrentSeries,
                    panaType: 'Triple Pana'
                });
                
                // Update bids
                const updatedBids = [...bids, ...allCombinations];
                setBids(updatedBids);
                
                const updatedSourceSeries = [...existingSourceSeries, digitsInCurrentSeries];
                const displayValue = updatedSourceSeries.join(',');
                setAutoInputValue(displayValue + ',');
                
                const dpCount = allCombinations.length - 1; // All except TP
                
                setErrorMessage({ 
                    status: true, 
                    message: `Series SP DP TP: Added ${allCombinations.length} combinations (${dpCount} DP + 1 TP) for digits: ${digitsInCurrentSeries}`, 
                    severity: 'success', 
                    inputName: '' 
                });
            } else {
                // Case: Different digits (e.g., "12", "34", "123")
                
                // 1. Generate all SP combinations with input digits
                const spCombinations = generateSeriesSPCombinations(inputDigits);
                spCombinations.forEach(combo => {
                    allCombinations.push({
                        digits: combo,
                        closedigits: '',
                        points: parseInt(currentPoints),
                        sourceSeries: digitsInCurrentSeries,
                        panaType: 'Single Pana'
                    });
                });
                
                // 2. Generate DP combinations - each input digit as repeating digit with others as single
                uniqueDigits.forEach(repeatingDigit => {
                    uniqueDigits.forEach(singleDigit => {
                        if (singleDigit === repeatingDigit) return;
                        
                        // Generate 3 permutations for this DP combination
                        const perm1 = repeatingDigit + repeatingDigit + singleDigit; // AAB: 112
                        const perm2 = singleDigit + repeatingDigit + repeatingDigit; // BAA: 211
                        const perm3 = repeatingDigit + singleDigit + repeatingDigit; // ABA: 121
                        
                        [perm1, perm2, perm3].forEach(perm => {
                            allCombinations.push({
                                digits: perm,
                                closedigits: '',
                                points: parseInt(currentPoints),
                                sourceSeries: digitsInCurrentSeries,
                                panaType: 'Double Pana'
                            });
                        });
                    });
                });
                
                // Update bids
                const updatedBids = [...bids, ...allCombinations];
                setBids(updatedBids);
                
                const updatedSourceSeries = [...existingSourceSeries, digitsInCurrentSeries];
                const displayValue = updatedSourceSeries.join(',');
                setAutoInputValue(displayValue + ',');
                
                const spCount = spCombinations.length;
                const dpCount = allCombinations.length - spCount;
                
                setErrorMessage({ 
                    status: true, 
                    message: `Series SP DP TP: Added ${allCombinations.length} combinations (${spCount} SP + ${dpCount} DP) for digits: ${inputDigits.join('')}`, 
                    severity: 'success', 
                    inputName: '' 
                });
            }
        } else {
            setAutoInputValue(value);
            if (digitsInCurrentSeries.length > 0 && digitsInCurrentSeries.length < 2) {
                setErrorMessage({ 
                    status: true, 
                    message: `Need at least 2 different digits for series. Currently have: ${digitsInCurrentSeries.length}`, 
                    severity: 'info', 
                    inputName: '' 
                });
            }
        }
    };

    // Handle All SP DP TP auto-generation (gameTypeId 13)
    const handleAllSPDPTPInput = (value: string) => {
        const digitsOnly = value.replace(/[^0-9]/g, '');
        
        // Get existing source digits from bids
        const existingSourceDigits: string[] = [];
        if (bids.length > 0) {
            bids.forEach((bid: any) => {
                if (bid.sourceDigit && !existingSourceDigits.includes(bid.sourceDigit)) {
                    existingSourceDigits.push(bid.sourceDigit);
                }
            });
        }
        
        const currentDigitCount = existingSourceDigits.length;
        
        // Handle backspace/deletion
        const previousValue = autoInputValue.replace(/,\s*$/, '');
        const currentValue = value.replace(/,\s*$/, '');
        
        if (currentValue.length < previousValue.length && bids.length > 0) {
            const prevDigits = previousValue.split(',').filter((d: string) => d.length === 1);
            const newDigits = currentValue.split(',').filter((d: string) => d.length === 1);
            
            if (prevDigits.length > newDigits.length && existingSourceDigits.length > 0) {
                // Remove last digit's bids
                const lastSourceDigit = existingSourceDigits[existingSourceDigits.length - 1];
                const newBids = bids.filter((bid: any) => bid.sourceDigit !== lastSourceDigit);
                setBids(newBids);
                
                const remainingSourceDigits = existingSourceDigits.slice(0, -1);
                const displayValue = remainingSourceDigits.join(',');
                setAutoInputValue(displayValue ? displayValue + ',' : '');
                setErrorMessage({ status: true, message: 'Last digit removed!', severity: 'info', inputName: '' });
                return;
            }
        }
        
        // Parse input - need at least 1 digit
        if (digitsOnly.length > currentDigitCount) {
            const inputDigit = digitsOnly[currentDigitCount];
            const targetSumLastDigit = parseInt(inputDigit);
            const allCombinations: any[] = [];
            
            // Generate ALL panna (000-999) where digit sum's last digit = input digit
            for (let num = 0; num <= 999; num++) {
                const numStr = num.toString().padStart(3, '0');
                
                // Calculate sum of digits
                const digit1 = parseInt(numStr[0]);
                const digit2 = parseInt(numStr[1]);
                const digit3 = parseInt(numStr[2]);
                const digitSum = digit1 + digit2 + digit3;
                const sumLastDigit = digitSum % 10; // Get last digit of sum
                
                // Check if sum's last digit matches input digit
                if (sumLastDigit !== targetSumLastDigit) continue;
                
                // Detect pana type
                const panaType = detectPanaType(numStr);
                let panaTypeName = '';
                
                if (panaType === 'SP') {
                    panaTypeName = 'Single Pana';
                } else if (panaType === 'DP') {
                    panaTypeName = 'Double Pana';
                } else if (panaType === 'TP') {
                    panaTypeName = 'Triple Pana';
                }
                
                allCombinations.push({
                    digits: numStr,
                    closedigits: '',
                    points: parseInt(currentPoints),
                    sourceDigit: inputDigit,
                    panaType: panaTypeName
                });
            }
            
            // Add to existing bids
            const updatedBids = [...bids, ...allCombinations];
            setBids(updatedBids);
            
            // Update display value
            const updatedSourceDigits = [...existingSourceDigits, inputDigit];
            const displayValue = updatedSourceDigits.join(',');
            setAutoInputValue(displayValue + ',');
            
            // Count by type
            const spCount = allCombinations.filter(c => c.panaType === 'Single Pana').length;
            const dpCount = allCombinations.filter(c => c.panaType === 'Double Pana').length;
            const tpCount = allCombinations.filter(c => c.panaType === 'Triple Pana').length;
            
            setErrorMessage({ 
                status: true, 
                message: `All SP DP TP: Added ${allCombinations.length} combinations (${spCount} SP + ${dpCount} DP + ${tpCount} TP) for sum digit: ${inputDigit}`, 
                severity: 'success', 
                inputName: '' 
            });
        } else {
            setAutoInputValue(value);
        }
    };

    // Detect if number is SP, DP, or TP
    const detectPanaType = (num: string) => {
        if (num.length !== 3) return null;
        
        const digits = num.split('');
        const uniqueDigits = new Set(digits);
        
        if (uniqueDigits.size === 3) {
            return 'SP'; // All different digits
        } else if (uniqueDigits.size === 2) {
            return 'DP'; // Exactly 2 digits same
        } else if (uniqueDigits.size === 1) {
            return 'TP'; // All same digits
        }
        return null;
    };

    // Handle SP DP Motor input (gameTypeId 15) - Combination of SP and DP Motor
    const handleSPDPMotorInput = (value: string) => {
        const digitsOnly = value.replace(/[^0-9]/g, '');
        
        // Need at least 2 unique digits to generate both SP and DP motor
        const uniqueSet = new Set(digitsOnly.split(''));
        const uniqueDigits = Array.from(uniqueSet);
        
        if (uniqueDigits.length >= 3) {
            const allCombinations: any[] = [];
            
            // 1. Generate all SP Motor permutations
            const spPermutations = generateSPPermutations(digitsOnly);
            spPermutations.forEach(perm => {
                allCombinations.push({
                    digits: perm,
                    closedigits: '',
                    points: parseInt(currentPoints),
                    panaType: 'Single Pana'
                });
            });
            
            // 2. Generate all DP Motor permutations
            const dpPermutations = generateDPPermutations(digitsOnly);
            dpPermutations.forEach(perm => {
                allCombinations.push({
                    digits: perm,
                    closedigits: '',
                    points: parseInt(currentPoints),
                    panaType: 'Double Pana'
                });
            });
            
            setBids(allCombinations);
            setAutoInputValue(digitsOnly);
            
            const spCount = spPermutations.length;
            const dpCount = dpPermutations.length;
            
            setErrorMessage({ 
                status: true, 
                message: `SP DP Motor: Generated ${allCombinations.length} combinations (${spCount} SP Motor + ${dpCount} DP Motor) from digits: ${uniqueDigits.join('')}`, 
                severity: 'success', 
                inputName: '' 
            });
        } else {
            setAutoInputValue(value);
            if (digitsOnly.length > 0 && uniqueDigits.length < 3) {
                setErrorMessage({ 
                    status: true, 
                    message: `Need at least 3 different digits. Currently have: ${uniqueDigits.length}`, 
                    severity: 'info', 
                    inputName: '' 
                });
            }
        }
    };

    // Handle Panna input (gameTypeId 14) - Manual single panna entry with auto-comma
    const handlePannaInput = (value: string) => {
        const digitsOnly = value.replace(/[^0-9]/g, '');
        
        // Calculate how many complete 3-digit entries we can form
        const totalPossibleEntries = Math.floor(digitsOnly.length / 3);
        const currentBidsCount = bids.length;
        
        // Handle backspace/deletion
        const previousValue = autoInputValue.replace(/,\s*$/, '');
        const currentValue = value.replace(/,\s*$/, '');
        
        if (currentValue.length < previousValue.length && bids.length > 0) {
            const prevNumbers = previousValue.split(',').filter((n: string) => n.length === 3);
            const newNumbers = currentValue.split(',').filter((n: string) => n.length === 3);
            
            if (prevNumbers.length > newNumbers.length) {
                // Remove last bid
                const newBids = bids.slice(0, -1);
                setBids(newBids);
                
                const displayValue = newNumbers.join(',');
                setAutoInputValue(displayValue ? displayValue + ',' : '');
                setErrorMessage({ status: true, message: 'Last panna removed!', severity: 'info', inputName: '' });
                return;
            }
        }
        
        // Process new entries
        if (totalPossibleEntries > currentBidsCount) {
            const startPos = currentBidsCount * 3;
            const number = digitsOnly.substring(startPos, startPos + 3);
            
            if (number.length === 3) {
                // Detect pana type and validate
                const panaType = detectPanaType(number);
                
                if (!panaType) {
                    setErrorMessage({ 
                        status: true, 
                        message: `Invalid panna: ${number}`, 
                        severity: 'error', 
                        inputName: '' 
                    });
                    const displayValue = bids.map((bid: any) => bid.digits).join(',');
                    setAutoInputValue(displayValue ? displayValue + ',' : '');
                    return;
                }
                
                let panaTypeName = '';
                if (panaType === 'SP') {
                    panaTypeName = 'Single Pana';
                } else if (panaType === 'DP') {
                    panaTypeName = 'Double Pana';
                } else if (panaType === 'TP') {
                    panaTypeName = 'Triple Pana';
                }
                
                const newBid = {
                    digits: number,
                    closedigits: '',
                    points: parseInt(currentPoints),
                    panaType: panaTypeName
                };
                
                const updatedBids = [...bids, newBid];
                setBids(updatedBids);
                
                // Build display value with auto-comma
                const displayNumbers = updatedBids.map((bid: any) => bid.digits);
                const displayValue = displayNumbers.join(',');
                setAutoInputValue(displayValue + ',');
                
                setErrorMessage({ 
                    status: true, 
                    message: `Panna: Added ${number} (${panaTypeName})`, 
                    severity: 'success', 
                    inputName: '' 
                });
            }
        } else {
            setAutoInputValue(value);
            if (digitsOnly.length > 0 && digitsOnly.length % 3 !== 0) {
                const remaining = 3 - (digitsOnly.length % 3);
                setErrorMessage({ 
                    status: true, 
                    message: `Need ${remaining} more digit(s) to complete panna`, 
                    severity: 'info', 
                    inputName: '' 
                });
            }
        }
    };

    // Handle Block input (gameTypeId 12) - Only SP and DP, no TP
    const handleBlockInput = (value: string) => {
        const digitsOnly = value.replace(/[^0-9]/g, '');
        
        // Get unique source numbers from existing bids to count how many blocks are already added
        const existingSourceNumbers: string[] = [];
        if (bids.length > 0) {
            bids.forEach((bid: any) => {
                if (bid.sourceNumber && !existingSourceNumbers.includes(bid.sourceNumber)) {
                    existingSourceNumbers.push(bid.sourceNumber);
                }
            });
        }
        const currentBlocksCount = existingSourceNumbers.length;
        
        // Calculate how many complete 3-digit entries we can form from input
        const totalPossibleBlocks = Math.floor(digitsOnly.length / 3);
        
        // Handle backspace/deletion - if input value becomes shorter, remove last bid group
        const previousValue = autoInputValue.replace(/,\s*$/, '');
        const currentValue = value.replace(/,\s*$/, '');
        
        if (currentValue.length < previousValue.length && bids.length > 0) {
            // User is deleting - need to remove the last group of bids
            const prevNumbers = previousValue.split(',').filter((n: string) => n.length === 3);
            const newNumbers = currentValue.split(',').filter((n: string) => n.length === 3);
            
            if (prevNumbers.length > newNumbers.length && existingSourceNumbers.length > 0) {
                // Remove last source number's bids
                const lastSourceNumber = existingSourceNumbers[existingSourceNumbers.length - 1];
                const newBids = bids.filter((bid: any) => bid.sourceNumber !== lastSourceNumber);
                setBids(newBids);
                
                // Rebuild input value from remaining source numbers
                const remainingSourceNumbers = existingSourceNumbers.slice(0, -1);
                const displayValue = remainingSourceNumbers.join(',');
                setAutoInputValue(displayValue ? displayValue + ',' : '');
                setErrorMessage({ status: true, message: 'Last block removed!', severity: 'info', inputName: '' });
                return;
            }
        }
        
        // Process new blocks if we have more possible blocks than current blocks
        if (totalPossibleBlocks > currentBlocksCount) {
            // Extract the next 3-digit entry
            const startPos = currentBlocksCount * 3;
            const number = digitsOnly.substring(startPos, startPos + 3);
            
            if (number.length === 3) {
                const panaType = detectPanaType(number);
                
                if (panaType === 'TP') {
                    // Triple Pana not allowed in Block
                    setErrorMessage({ 
                        status: true, 
                        message: `Triple Pana (${number}) NOT allowed in Block! Only SP and DP allowed.`, 
                        severity: 'error', 
                        inputName: '' 
                    });
                    // Reset to previous valid state
                    const displayValue = existingSourceNumbers.join(',');
                    setAutoInputValue(displayValue ? displayValue + ',' : '');
                    return;
                }
                
                let newPermutations: string[] = [];
                let newPanaType = '';
                
                // For Block, generate permutations of the exact number entered
                if (panaType === 'SP' || panaType === 'DP') {
                    // Generate specific permutations of this 3-digit number
                    newPermutations = generateStringPermutations(number);
                    newPanaType = panaType === 'SP' ? 'Single Pana' : 'Double Pana';
                }
                
                // Create new bids for this number
                const newBidsForNumber = newPermutations.map(perm => ({
                    digits: perm,
                    closedigits: '',
                    points: parseInt(currentPoints),
                    panaType: newPanaType,
                    sourceNumber: number
                }));
                
                // Add to existing bids
                const updatedBids = [...bids, ...newBidsForNumber];
                setBids(updatedBids);
                
                // Build display value - show source numbers separated by comma
                const updatedSourceNumbers = [...existingSourceNumbers, number];
                const displayValue = updatedSourceNumbers.join(',');
                setAutoInputValue(displayValue + ',');
                
                setErrorMessage({ 
                    status: true, 
                    message: `Block ${panaType}: Added ${newPermutations.length} ${newPanaType} combinations from ${number}`, 
                    severity: 'success', 
                    inputName: '' 
                });
            }
        } else {
            setAutoInputValue(value);
            if (digitsOnly.length > 0 && digitsOnly.length % 3 !== 0) {
                const remaining = 3 - (digitsOnly.length % 3);
                setErrorMessage({ 
                    status: true, 
                    message: `Need ${remaining} more digit(s) to complete block number`, 
                    severity: 'info', 
                    inputName: '' 
                });
            }
        }
    };

    // Get placeholder text based on game type
    const getPlaceholderText = () => {
        switch(gameTypeId) {
            case '1': return 'Type: 1,3,5,7...';
            case '2': return 'Type: 00,12,34,56...';
            case '3': return 'Type: 123,456,789...';
            case '4': return 'Type: 220,303,455...';
            case '5': return 'Type: 111,222,333...';
            case '6': return 'Type: 12345 (auto-generates all SP combinations)';
            case '7': return 'Type: 12345 (auto-generates all DP combinations)';
            case '8': return 'Type: A1,B5,C10,J11 (Manual comma)';
            case '9': return 'Type: 12,34,97... (Series SP Multiple)';
            case '10': return 'Type: 11,22,33... (Series DP Multiple)';
            case '11': return 'Type: 12,34,97... (Series SP DP TP Auto)';
            case '12': return 'Type: 123,221,456... (Block - Multiple SP/DP)';
            case '13': return 'Type: 1,2,3... (All SP DP TP)';
            case '14': return 'Type: 123,221,111... (Panna)';
            case '15': return 'Type: 12345 (SP DP Motor Combo)';
            default: return 'Type numbers...';
        }
    };

    // Get helper text based on game type
    const getHelperText = () => {
        switch(gameTypeId) {
            case '1': return 'Type single digits (0-9), auto-adds with comma';
            case '2': return 'Type 2-digit numbers (00-99), auto-adds with comma';
            case '3': return 'Type 3-digit numbers with ALL DIFFERENT digits (e.g., 123, 456) - No repeating digits!';
            case '4': return 'Type 3-digit numbers with EXACTLY 2 MATCHING digits (e.g., 220, 303, 455) - Double Pana only!';
            case '5': return 'Type 3-digit numbers where ALL digits are SAME (e.g., 111, 222, 333) - Triple Pana only!';
            case '6': return 'Type any digits (minimum 3 unique) - Auto-generates ALL SP Pana combinations! (e.g., 12345 → 123,124,125,132...)';
            case '7': return 'Type any digits (minimum 2 unique) - Auto-generates ALL DP Pana combinations! (e.g., 12345 → 112,113,114,221,223...)';
            case '8': return 'Jackpot: Type codes with MANUAL comma (A1,B5,C10,J11). Alphabets A-J, Numbers 1-11. Type full code then comma for next!';
            case '9': return 'Series SP: Type multiple series (e.g., 12,34,97). Each series (2+ digits) auto-generates ALL SP combinations. Auto-comma after complete series. No repeated digits!';
            case '10': return 'Series DP: Type multiple series (e.g., 11,22,33). Each series (2+ digits, repetition allowed) auto-generates ALL DP combinations. Auto-comma after complete series!';
            case '11': return 'Series SP DP TP: Type series (e.g., 12,11,22). For different digits (12) → SP+DP. For same digits (11,22) → DP+TP!';
            case '12': return 'Block: Type multiple SP/DP numbers (e.g., 123,221,456). Each auto-generates permutations. TP NOT allowed!';
            case '13': return 'All SP DP TP: Type single digits (e.g., 1,2,3). For each digit, generates ALL panna where digit SUM ends with that digit (e.g., 1→100,777,209...). Auto-comma support!';
            case '14': return 'Panna: Type 3-digit panna numbers (e.g., 123,221,111). Each number added as-is. Mix of SP/DP/TP allowed! Auto-comma support.';
            case '15': return 'SP DP Motor: Type any digits (minimum 3 unique) - Auto-generates BOTH SP Motor AND DP Motor combinations! (e.g., 12345 → all SP + all DP)';
            default: return 'Type numbers, auto-adds with comma';
        }
    };

    const getTotalPoints = () => {
        return bids.reduce((sum: number, bid: any) => sum + bid.points, 0);
    };

    const getWinningRate = (bid?: any) => {
        if (!fatafatDollarGameRateData || !fatafatDollarGameRateData.game_rates) return 0;
        
        const rates = fatafatDollarGameRateData.game_rates;
        
        // For games with panaType in bid, use that to determine rate
        if ((gameTypeId === '12' || gameTypeId === '11' || gameTypeId === '13' || gameTypeId === '14' || gameTypeId === '15') && bid && bid.panaType) {
            if (bid.panaType === 'Single Pana') {
                return rates.single_pana_val_2;
            } else if (bid.panaType === 'Double Pana') {
                return rates.double_pana_val_2;
            } else if (bid.panaType === 'Triple Pana') {
                return rates.tripple_pana_val_2;
            }
        }
        
        switch(gameTypeName) {
            case 'Single Digit': return rates.single_digit_val_2;
            case 'Jodi Digit': return rates.jodi_digit_val_2;
            case 'Single Pana': return rates.single_pana_val_2;
            case 'Double Pana': return rates.double_pana_val_2;
            case 'Triple Pana': return rates.tripple_pana_val_2;
            case 'SP Motor': return rates.single_pana_val_2; // SP Motor uses SP rate
            case 'DP Motor': return rates.double_pana_val_2; // DP Motor uses DP rate
            case 'Jackpot': return rates.jackpot_val_2 || 0; // Jackpot rate
            case 'Series SP': return rates.single_pana_val_2; // Series SP uses SP rate
            case 'Series DP': return rates.double_pana_val_2; // Series DP uses DP rate
            case 'Series SP DP TP': return rates.single_pana_val_2; // Series SP DP TP default SP rate
            case 'Block': return rates.single_pana_val_2; // Block default SP rate
            case 'All SP DP TP': return rates.single_pana_val_2; // All SP DP TP uses SP rate
            case 'Panna': return rates.single_pana_val_2; // Panna default SP rate
            case 'SP DP Motor': return rates.single_pana_val_2; // SP DP Motor default SP rate
            default: return 0;
        }
    };

    const submitBids = async () => {
        if (bids.length === 0) {
            setErrorMessage({ status: true, message: 'Please add at least one bid', severity: 'warning', inputName: '' });
            return;
        }

        // For Jodi game type, use 'Open' session (as Jodi saves in Open session)
        const sessionToUse = gameTypeId === '2' ? 'Open' : selectedSession;

        // Check game status before submitting
        const statusCheck = await checkGameStatus(sessionToUse);
        if (statusCheck && !statusCheck.status) {
            setErrorMessage({ status: true, message: statusCheck.msg, severity: 'error', inputName: '' });
            return;
        }

        const bidData = {
            app_key: "@34Y@#8deepmatka",
            user_id: userData?.user_id || '',
            game_id: gameId,
            game_name: "Fatafat Dollar Game",
            pana: gameTypeName,
            session: sessionToUse,
            bid_date: new Date().toISOString().split('T')[0],
            bids: bids
        };

        dispatch(fatafatDollarActions.submitFatafatDollarBidReq(bidData));
    };

    const handleClose = (event: any, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setErrorMessage({ status: false, message: "", severity: "", inputName: '' });
    };

    return (
        <div>
            <CustomAppBar title={gameTypeLabel || 'Place Bid'} isBack={true} />
            <Container sx={{ paddingLeft: '0px !important', paddingRight: '0px !important', marginTop: '70px !important', paddingBottom: '80px' }}>
                
                {/* Game Info */}
                <Card sx={{ margin: 2, padding: 2, background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>{gameTypeLabel}</Typography>
                    <Typography variant="body2">Win Rate: ₹{getWinningRate()} per ₹1</Typography>
                </Card>

                {/* Session Selection - Hide for Jodi */}
                {gameTypeId !== '2' && (
                    <Card sx={{ margin: 2, padding: 2 }}>
                        <Typography variant="h6" sx={{ marginBottom: 2, color: '#667eea' }}>Select Session</Typography>
                        <FormControl component="fieldset">
                            <FormLabel component="legend" sx={{ color: '#333', fontWeight: 'bold', marginBottom: 1 }}>
                                Choose Session for Bid
                            </FormLabel>
                            <RadioGroup
                                row
                                value={selectedSession}
                                onChange={(e: any) => {
                                    setSelectedSession(e.target.value);
                                    checkGameStatus(e.target.value);
                                }}
                                sx={{ justifyContent: 'center', gap: 3 }}
                            >
                                <FormControlLabel 
                                    value="Open" 
                                    control={<Radio sx={{ color: '#28a745', '&.Mui-checked': { color: '#28a745' } }} />} 
                                    label={
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Typography sx={{ fontWeight: 'bold', color: '#28a745' }}>Open</Typography>
                                            {gameTiming && (
                                                <Typography variant="caption" sx={{ color: '#666' }}>
                                                    ({gameTiming.open_time})
                                                </Typography>
                                            )}
                                        </Box>
                                    }
                                />
                                <FormControlLabel 
                                    value="Close" 
                                    control={<Radio sx={{ color: '#dc3545', '&.Mui-checked': { color: '#dc3545' } }} />} 
                                    label={
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Typography sx={{ fontWeight: 'bold', color: '#dc3545' }}>Close</Typography>
                                            {gameTiming && (
                                                <Typography variant="caption" sx={{ color: '#666' }}>
                                                    ({gameTiming.close_time})
                                                </Typography>
                                            )}
                                        </Box>
                                    }
                                />
                            </RadioGroup>
                        </FormControl>
                        <Typography variant="body2" sx={{ marginTop: 1, textAlign: 'center', color: '#666' }}>
                            Selected Session: <span style={{ color: selectedSession === 'Open' ? '#28a745' : '#dc3545', fontWeight: 'bold' }}>{selectedSession}</span>
                        </Typography>
                        
                        {/* Game Status Message */}
                        {gameStatus && !gameStatus.status && (
                            <Box sx={{ marginTop: 2, padding: 2, backgroundColor: '#f8d7da', borderRadius: '8px', border: '1px solid #f5c6cb' }}>
                                <Typography variant="body2" sx={{ color: '#721c24', textAlign: 'center', fontWeight: 'bold' }}>
                                    🚫 {gameStatus.msg}
                                </Typography>
                            </Box>
                        )}
                    </Card>
                )}

                {/* Add Bid Form */}
                <Card sx={{ margin: 2, padding: 2 }}>
                    <Typography variant="h6" sx={{ marginBottom: 2, color: '#667eea' }}>
                        Add Numbers (Auto Add)
                    </Typography>
                    
                    {/* Auto input for ALL game types */}
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Points per Number *"
                                type="number"
                                value={currentPoints}
                                onChange={(e: any) => setCurrentPoints(e.target.value)}
                                inputProps={{ min: outletdata?.walletBalance?.min_bid_amount || 10 }}
                                helperText={`Min: ₹${outletdata?.walletBalance?.min_bid_amount || 10} - Enter points first, then type numbers below`}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: !currentPoints ? '#ff9800' : undefined,
                                            borderWidth: !currentPoints ? '2px' : '1px'
                                        }
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label={`Enter ${gameTypeLabel}`}
                                value={autoInputValue}
                                onChange={handleAutoInput}
                                placeholder={getPlaceholderText()}
                                helperText={getHelperText()}
                                disabled={!currentPoints || currentPoints === ''}
                                sx={{
                                    '& input': {
                                        fontSize: '18px',
                                        letterSpacing: '2px'
                                    }
                                }}
                            />
                        </Grid>
                        
                        {/* Jackpot Suggestions */}
                        {gameTypeId === '8' && jackpotSuggestions.length > 0 && (
                            <Grid item xs={12}>
                                <Box sx={{ 
                                    padding: 2, 
                                    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', 
                                    borderRadius: '8px',
                                    border: '2px solid #667eea'
                                }}>
                                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#667eea', marginBottom: 1 }}>
                                        💡 Quick Select (Click to Add):
                                    </Typography>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                        {jackpotSuggestions.map((suggestion: string) => (
                                            <Chip
                                                key={suggestion}
                                                label={suggestion}
                                                onClick={() => handleJackpotSuggestionClick(suggestion)}
                                                sx={{
                                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                    color: 'white',
                                                    fontWeight: 'bold',
                                                    fontSize: '14px',
                                                    cursor: 'pointer',
                                                    '&:hover': {
                                                        background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)',
                                                        transform: 'scale(1.05)',
                                                    },
                                                    transition: 'all 0.2s'
                                                }}
                                            />
                                        ))}
                                    </Box>
                                </Box>
                            </Grid>
                        )}
                        
                        {bids.length > 0 && (
                            <Grid item xs={12}>
                                <Button 
                                    fullWidth 
                                    variant="outlined" 
                                    color="error"
                                    onClick={() => {
                                        setBids([]);
                                        setAutoInputValue('');
                                    }}
                                    sx={{ 
                                        padding: '10px',
                                        fontSize: '14px',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    🗑️ Clear All Numbers
                                </Button>
                            </Grid>
                        )}
                    </Grid>
                </Card>

                {/* Bid Cart */}
                {bids.length > 0 && (
                    <Card sx={{ margin: 2, padding: 2 }}>
                        <Typography variant="h6" sx={{ marginBottom: 2, color: '#667eea' }}>
                            Bid Cart ({bids.length} items)
                        </Typography>
                        <Box sx={{ maxHeight: '300px', overflowY: 'auto' }}>
                            {bids.map((bid: any, index: number) => (
                                <Card key={index} sx={{ marginBottom: 1, padding: 2, background: '#f8f9fa' }}>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs={4}>
                                            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                                Number: {bid.digits}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="body2" sx={{ color: '#28a745', fontWeight: 'bold' }}>
                                                Points: ₹{bid.points}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4} sx={{ textAlign: 'right' }}>
                                            <Button 
                                                size="small" 
                                                color="error" 
                                                onClick={() => removeBid(index)}
                                            >
                                                Remove
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="caption" sx={{ color: '#666' }}>
                                                {bid.panaType && <span style={{ fontWeight: 'bold', color: '#667eea' }}>({bid.panaType}) </span>}
                                                Potential Win: ₹{bid.points * getWinningRate(bid)}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Card>
                            ))}
                        </Box>

                        {/* Total */}
                        <Box sx={{ marginTop: 2, padding: 2, background: '#fff3cd', borderRadius: '8px' }}>
                            <Grid container>
                                <Grid item xs={6}>
                                    <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                        Total Amount:
                                    </Typography>
                                </Grid>
                                <Grid item xs={6} sx={{ textAlign: 'right' }}>
                                    <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#dc3545' }}>
                                        ₹{getTotalPoints()}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Box>

                        {/* Submit Button */}
                        <Button 
                            fullWidth 
                            variant="contained" 
                            onClick={submitBids}
                            disabled={isFatafatDollarLoading}
                            sx={{ 
                                marginTop: 2,
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                padding: '15px',
                                fontSize: '18px',
                                fontWeight: 'bold'
                            }}
                        >
                            {isFatafatDollarLoading ? <CircularProgress size={24} /> : '🚀 Submit All Bids'}
                        </Button>
                    </Card>
                )}
            </Container>
            <AlertBar handleClose={handleClose} errorMessage={errorMessage} />
        </div>
    );
}

const mapStateToProps = (state: any) => ({
    isFatafatDollarLoading: state.fatafatdollar.isFatafatDollarLoading,
    fatafatDollarGameRateData: state.fatafatdollar.fatafatDollarGameRateData,
    isSubmitFatafatDollarBidSuccess: state.fatafatdollar.isSubmitFatafatDollarBidSuccess,
    isSubmitFatafatDollarBidFailed: state.fatafatdollar.isSubmitFatafatDollarBidFailed,
    fatafatDollarMsg: state.fatafatdollar.fatafatDollarMsg,
})

export default connect(mapStateToProps)(FatafatDollarPlaceBid);

